import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { ContactInfoCard } from '@/modules/appointment/components/contact-info-card/ContactInfoCard'

import type { Encounter } from '../../types/encounter.types'

type Props = {
  encounter?: Encounter
  onPhoneClick: () => void
}

const EncounterContact = ({ encounter, onPhoneClick }: Props) => {
  const theme = useTheme()

  const location = encounter?.meta?.location
  const name =
    location?.name ||
    t({
      id: 'globals.azmm-contact.name',
      comment: 'General contact info name of AZMM',
      message: 'AZ Maria Middelares',
    })
  const street = location?.address?.street
  const zipCity = [location?.address?.postcode, location?.address?.city].filter(Boolean).join(' ')
  const phone =
    location?.phone ||
    t({
      id: 'globals.azmm-contact.phone',
      comment: 'General contact info phone number of AZMM',
      message: '+32 9 246 46 46',
    })

  return (
    <>
      <FlexColumn gap={theme.UI.Spacing.Space3}>
        <Span type='BodyMediumBold'>
          {t({
            id: 'encounters.detail.info',
            message: 'Meer informatie over je geplande opname?',
          })}
        </Span>
        <Span type='BodyMediumRegular'>
          {t({
            id: 'encounters.detail.contact',
            comment: 'Contact message for encounter detail',
            message: 'Neem contact op met je behandelend zorgverlener.',
          })}
        </Span>
      </FlexColumn>

      <ContactInfoCard>
        <ContactInfoCard.Name>{name}</ContactInfoCard.Name>
        {street ? <ContactInfoCard.Address>{street}</ContactInfoCard.Address> : null}
        {zipCity ? <ContactInfoCard.Address>{zipCity}</ContactInfoCard.Address> : null}
        <ContactInfoCard.Phone href={`tel:${phone}`} onClick={onPhoneClick}>
          <ContactInfoCard.PhoneNumber>{phone}</ContactInfoCard.PhoneNumber>
          <ContactInfoCard.Icon icon={['fal', 'phone']} />
        </ContactInfoCard.Phone>
      </ContactInfoCard>
    </>
  )
}

export { EncounterContact }
